// packages/i18n/src/sprintf.ts
import _sprintf from "@tannin/sprintf";
function sprintf(format, ...args) {
  return _sprintf(format, ...args);
}
export {
  sprintf
};
//# sourceMappingURL=sprintf.js.map
